import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
  viewChild
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { UtilityService } from "src/app/core/services/utility.service";
import { BaseFormPageComponent } from "src/app/pages/shared/base/components/base-form-page.component";

@Component({
    selector: "app-sms-body-signature",
    templateUrl: "./sms-body-signature.component.html",
    styleUrls: ["./sms-body-signature.component.scss"],
    standalone: false
})
export class SmsBodySignatureComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  fields = "pages.customerDomains.form.fields.";
  readonly organSignatureInput = viewChild<ElementRef>("organSignature");
  signature: string;
  organizationSignature: string;
  isOrganSignatureAtFirst: boolean = false;
  smsBody: string;
  smsBodyWithSignatures: string;
  isExitSignatureInSmsBody: boolean;
  //#endregion

  constructor(
    private renderer: Renderer2,

    private utilityService: UtilityService,
    private dialogRef: MatDialogRef<SmsBodySignatureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.smsBody = data?.smsBody;
    this.organizationSignature = data?.organizationSignature;
    this.signature = data?.signature;
    this.isOrganSignatureAtFirst = data?.isOrganSignatureAtFirst || false;
  }

  ngOnInit() {
    this.initForm();
    const organSignatureInput = this.organSignatureInput();
    if (organSignatureInput)
      this.renderer.setProperty(
        organSignatureInput.nativeElement,
        "value",
        this.organizationSignature
      );
    this.handleSignaturesPosition();

    //agar emzaye khat dar matn vojood dashte base hamishe emzaye sazman akhar miyad
    this.isExitSignatureInSmsBody = this.smsBody?.includes(this.signature);
    if (this.isExitSignatureInSmsBody) this.isOrganSignatureAtFirst = false;
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      signature: new FormControl(this.signature),
      organizationSignature: new FormControl(this.organizationSignature),
      smsBody: new FormControl(),
      isAddSignature: new FormControl(),
      signaturePosition: new FormControl(),
      isOrganSignatureAtFirst: new FormControl(),
      isSignatureAtFirst: new FormControl(),
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close({
      organizationSignature: this.organizationSignature,
      signature: this.signature,
      isOrganSignatureAtFirst: this.isOrganSignatureAtFirst,
    });
    this.unSubs();
  }

  onChangeOrganSignature(value: string) {
    const organSignatureInput = this.organSignatureInput();
    if (organSignatureInput)
      this.renderer.setProperty(
        organSignatureInput.nativeElement,
        "value",
        value
      );
    this.organizationSignature = value;
    this.handleSignaturesPosition();
  }

  onChangeSignaturePosition(event?) {
    this.isOrganSignatureAtFirst = event?.value || false;
    this.handleSignaturesPosition();
  }

  handleSignaturesPosition() {
    this.smsBodyWithSignatures = "";

    let englishSignature = this.utilityService.getTextWithEnglishNumber(
      this.signature
    );
    let persianSignature = this.utilityService.getTextWithArabicNumber(
      this.signature
    );

    this.isExitSignatureInSmsBody =
      this.smsBody?.includes(englishSignature) ||
      this.smsBody?.includes(persianSignature);

    if (this.isOrganSignatureAtFirst)
      this.smsBodyWithSignatures =
        (this.smsBody || "") +
        `${
          this.organizationSignature ? "\n" + this.organizationSignature : ""
        }` +
        `${
          this.signature && !this.isExitSignatureInSmsBody
            ? "\n" + this.signature
            : ""
        }`;
    else
      this.smsBodyWithSignatures =
        (this.smsBody || "") +
        `${
          this.signature && !this.isExitSignatureInSmsBody
            ? "\n" + this.signature
            : ""
        }` +
        `${
          this.organizationSignature ? "\n" + this.organizationSignature : ""
        }`;
  }
}
